<template>
  <div class="d-flex px-3 py-2 rounded quick-link"
       :class="cssClass"
       :style="styleCss"
       @click="onClick"
  >
    <div>{{ label }}</div>
    <div class="ml-auto align-self-center" v-if="icon">
      <slot name="icon"><custom-icon :icon="icon" /></slot>
    </div>
  </div>
</template>

<script>
import CustomIcon from '@/components/Custom/CustomIcon';

export default {
  name: 'QuickLink',
  components: {
    CustomIcon,
  },
  props: {
    label: {
      type: String,
      required: true,
    },
    url: {
      type: String,
    },
    route: {
      type: String,
    },
    icon: {
      type: String,
    },
    color: {
      type: String,
    },
    bgColor: {
      type: String,
      default: '#D4E7F8',
    },
    cssClass: {
      type: String,
    },
  },
  computed: {
    styleCss() {
      let style = '';
      if (this.color) {
        style = 'color: ' + this.color + ';';
      }

      if (this.bgColor) {
        style = style + 'background: ' + this.bgColor + ';';
      }

      return style;
    },
  },
  methods: {
    onClick() {
      if (this.route) {
        this.$router.push({ name: this.route });
      } else {
        window.location.href = this.url;
      }
    },
  },
};
</script>

<style scoped>
 .quick-link {
   background: #D4E7F8;
   font-weight: bolder;
   text-transform: uppercase;
   cursor: pointer;
 }
</style>
